module.exports = __webpack_public_path__ + "static/media/cervezas.8dda382e.jpg";